module.exports = __webpack_public_path__ + "rw-widgets.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.ttf?v=4.1.0
// module id = 798
// module chunks = 0